import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  income: [],
  tempIncome: [],
  isLoading: false,
  pagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
};

const incomeSlice = createSlice({
  name: "income",
  initialState,
  reducers: {
    setIncome(state, action) {
      state.income = action.payload;
      state.isLoading = false;
    },
    setTempIncome(state, action) {
      state.tempIncome = action.payload;
    },
    addIncome(state, action) {
      state.income.push(action.payload);
      state.tempIncome.push(action.payload);
    },
          setIncomePagination(state, action) {
          state.pagination = action.payload;
        },
    updateIncome(state, action) {
      const { index, income } = action.payload;
      console.log(index, income);
      state.income?.splice(index, 1, income);
      state.tempIncome?.splice(index, 1, income);
    },
    deleteIncome(state, action) {
      const { index } = action.payload;
      state.income.splice(index, 1);
      state.tempIncome.splice(index, 1);
    },
    setIncomeIsLoading(state, action) {
      state.isLoading = true;
    },
  },
});

export const {
  setIncome,
  setTempIncome,
  addIncome,
  updateIncome,
  deleteIncome,
  setIncomePagination,
  setIncomeIsLoading,
} = incomeSlice.actions;
export default incomeSlice.reducer;
